import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class LocationQueryCriteriaClass extends BaseCriteriaModel {
  //from header
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  guid_bl_fi_mst_branch?: Optional<string> = Optional.empty();
  guid_bl_fi_mst_comp?: Optional<string> = Optional.empty();

  //from extension
  created_date_from?: Optional<string> = Optional.empty();
  created_date_to?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
}

export class LocationCriteriaModelQuery {
  query = '';

  constructor( LocationCriteriaModel: LocationQueryCriteriaClass) {
    if (!LocationCriteriaModel) {
      return;
    }

    this.query += LocationCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += LocationCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += LocationCriteriaModel.guid_bl_fi_mst_branch.filter(x => x !== '').map(x => '&guid_bl_fi_mst_branch=' + x).orElse('');
    this.query += LocationCriteriaModel.guid_bl_fi_mst_comp.filter(x => x !== '').map(x => '&guid_bl_fi_mst_comp=' + x).orElse('');

    this.query += LocationCriteriaModel.created_date_from.filter(x => x !== '').map(x => '&created_date_from=' + x).orElse('');
    this.query += LocationCriteriaModel.created_date_to.filter(x => x !== '').map(x => '&created_date_to=' + x).orElse('');
    this.query += LocationCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += LocationCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += LocationCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += LocationCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += LocationCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');

    this.query += '&status=' + LocationCriteriaModel.status;
    // this.query += '&orderBy=' + LocationCriteriaModel.orderBy;
    this.query += '&order=' + LocationCriteriaModel.order;
    this.query += '&offset=' + LocationCriteriaModel.offset + '&limit=' + LocationCriteriaModel.limit;
  }
}
